import { ReactElement, useCallback } from 'react';

import {
  PeriodsTeacherPortal as Base,
  getPeriodsTeacherPortalRequest as getBase,
} from '../../api/requests/teacherPortal';
import DisplayError from '../Info/DisplayError';
import Loading from '../Info/Loading';
import { createFetchContext } from '../contexts/FetchContextFactory';

interface BaseLoaderProps<T> {
  children: (props: { data: T; refresh: () => Promise<void> }) => ReactElement;
}

const { FetchProvider, FetchConsumer } = createFetchContext<undefined, Base>();

export const BaseLoaderConsumer = FetchConsumer;

export function PeriodsLoader({ children }: BaseLoaderProps<Base>) {
  const request = useCallback(() => {
    return getBase();
  }, []);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return (
              <div className="mx-3">
                <Loading insideCard />
              </div>
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children({ data, refresh });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
